import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TelegramFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 4C7.584 4 4 7.584 4 12C4 16.416 7.584 20 12 20C16.416 20 20 16.416 20 12C20 7.584 16.416 4 12 4ZM15.712 9.44C15.592 10.704 15.072 13.776 14.808 15.192C14.696 15.792 14.472 15.992 14.264 16.016C13.8 16.056 13.448 15.712 13 15.416C12.296 14.952 11.896 14.664 11.216 14.216C10.424 13.696 10.936 13.408 11.392 12.944C11.512 12.824 13.56 10.96 13.6 10.792C13.6056 10.7666 13.6048 10.7401 13.5978 10.715C13.5909 10.6899 13.5779 10.6669 13.56 10.648C13.512 10.608 13.448 10.624 13.392 10.632C13.32 10.648 12.2 11.392 10.016 12.864C9.696 13.08 9.408 13.192 9.152 13.184C8.864 13.176 8.32 13.024 7.912 12.888C7.408 12.728 7.016 12.64 7.048 12.36C7.064 12.216 7.264 12.072 7.64 11.92C9.976 10.904 11.528 10.232 12.304 9.912C14.528 8.984 14.984 8.824 15.288 8.824C15.352 8.824 15.504 8.84 15.6 8.92C15.68 8.984 15.704 9.072 15.712 9.136C15.704 9.184 15.72 9.328 15.712 9.44Z" />
    </SvgIcon>
  );
});
